export var inlineStyles = [{
  icon: 'bold',
  label: 'Negrita',
  style: 'BOLD'
}, {
  icon: 'underline',
  label: 'Subrayado',
  style: 'UNDERLINE'
}];
export var headings = [{
  icon: 'heading',
  label: 'Título',
  style: 'header-four'
}, {
  icon: 'heading2',
  label: 'Subtítulo',
  style: 'header-five'
}];
export var blocks = [{
  icon: 'ul',
  label: 'Lista',
  style: 'unordered-list-item'
}, {
  icon: 'ol',
  label: 'Lista ordenada',
  style: 'ordered-list-item'
}, {
  icon: 'blockquote',
  label: 'Cita',
  style: 'blockquote'
}];